export enum SortBy {
	Asc = 'asc',
	Desc = 'desc'
}

export enum Modal {
	Delete = 'DELETE',
	Status = 'STATUS',
	Filter = 'FILTER',
	Logout = 'LOGOUT',
	Upload = 'UPLOAD',
	BulkUpload = 'BULK_UPLOAD',
	ReachedLimit = 'REACH_LIMIT',
	Save = 'SAVE',
	AddMarket = 'ADD_MARKET',
	EditMarket = 'EDIT_MARKET'
}

export enum Status {
	Active = 'active',
	Inactive = 'inactive'
}

export enum Role {
	Admin = 'Admin',
	SuperAdmin = 'Super Admin',
	Master = 'Master',
	User = 'User'
}

export enum NewsStatus {
	DRAFT = 'draft',
	PUBLISHED = 'published'
}
